document.addEventListener('DOMContentLoaded', () => {
  // add a class to page header background element to track when there's a background image
  let headerBackgroundInnerElements = document.querySelectorAll('#page-header .background-inner')
  if (headerBackgroundInnerElements) {
    headerBackgroundInnerElements.forEach(headerBackgroundInnerEl => {
      if (headerBackgroundInnerEl && headerBackgroundInnerEl.hasAttribute('style')) {
        headerBackgroundInnerEl.parentElement.parentElement.parentElement.classList.add('has-background-image')
      }
    })
  }
})
